const society = [
  {
    "id": 1,
    "level": "IEEE",
    "question": "If you get ₹50,000 funding, what social-impact project will you start?",
    "options": ["Pollution", "Education", "Healthcare", "Employment"],
    "correct": "Education",
    "hints": "Consider which sector has the most scalable impact with limited funding and can create long-term change."
  },
  {
    "id": 2,
    "level": "IEEE",
    "question": "How can technology solve a local community problem?",
    "options": ["Sensors", "Apps", "AI", "Automation"],
    "correct": "Apps",
    "hints": "Think about the most accessible and user-friendly technology that connects people directly to solutions."
  },
  {
    "id": 3,
    "level": "IEEE",
    "question": "How do satellites stay in orbit without falling to Earth?",
    "options": ["Gravity", "Speed", "Magnetism", "Fuel"],
    "correct": "Speed",
    "hints": "Satellites maintain orbital velocity, creating a balance between falling and moving forward."
  },
  {
    "id": 4,
    "level": "IEEE",
    "question": "Drone for disaster rescue: best feature?",
    "options": ["Camera", "GPS", "Payload", "Battery"],
    "correct": "GPS",
    "hints": "In disaster scenarios, precise location tracking and navigation are critical for effective rescue operations."
  },
  {
    "id": 5,
    "level": "IEEE",
    "question": "Difference between robotics and automation?",
    "options": ["Intelligence", "Sensors", "Movement", "Control"],
    "correct": "Intelligence",
    "hints": "Robotics involves adaptive decision-making, while automation typically follows pre-programmed sequences."
  },
  {
    "id": 6,
    "level": "IEEE",
    "question": "Robot for college: what problem will it solve?",
    "options": ["Security", "Cleaning", "Delivery", "Attendance"],
    "correct": "Attendance",
    "hints": "Consider which repetitive administrative task could be automated to save time and improve accuracy."
  },
  {
    "id": 7,
    "level": "IEEE",
    "question": "Smart grids are mainly for?",
    "options": ["Efficiency", "Generation", "Storage", "Billing"],
    "correct": "Efficiency",
    "hints": "Smart grids optimize power distribution and consumption using real-time data and intelligent control."
  },
  {
    "id": 8,
    "level": "IEEE",
    "question": "Biggest challenge in renewable energy?",
    "options": ["Cost", "Storage", "Weather", "Space"],
    "correct": "Storage",
    "hints": "Renewable sources are intermittent; the key challenge is storing energy for use when generation is low."
  },
  {
    "id": 9,
    "level": "IEEE",
    "question": "Which FACTS device is used for dynamic reactive power compensation?",
    "options": ["STATCOM", "SVC", "TCSC", "UPFC"],
    "correct": "STATCOM",
    "hints": "This device uses voltage source converters to provide fast reactive power support in transmission systems."
  },
  {
    "id": 10,
    "level": "IEEE",
    "question": "What is the name of the boundary where Earth's atmosphere merges into space?",
    "options": ["Kármán line", "Stratopause", "Exosphere", "Thermosphere"],
    "correct": "Kármán line",
    "hints": "This boundary is internationally recognized at approximately 100 km above sea level."
  }
]

export default society;